export const stats = [
  { value: '120+', label: 'Ready Coaching Modules' },
  { value: '2,500+', label: 'Coaches Trust Us' },
  { value: '3,500+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '120+', label: 'Ready Coaching Modules' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instant Download' },
]

export const beforeItems = [
  'Hours searching YouTube for drills',
  'Repeating the same exercises every week',
  'No progression across the season',
  'Panic when group sizes suddenly change',
  'Players losing motivation because practices feel random',
  "Sunday nights spent building Monday's session",
]

export const afterItems = [
  'Ready-to-run practices in minutes',
  'Structured technical progressions',
  'Professional session blueprints',
  'Adapt every drill for 3, 6 or 10+ players',
  'Built-in coaching cues',
  'A complete season already organized',
]

export const recognizeItems = [
  {
    emoji: '🎾',
    text: 'You spend hours searching for drills before every practice.',
  },
  {
    emoji: '⏰',
    text: 'Sunday evenings disappear planning another week.',
  },
  {
    emoji: '👥',
    text: 'Extra players arrive and your whole practice falls apart.',
  },
  {
    emoji: '📋',
    text: "You don't have a structured curriculum for the entire season.",
  },
  {
    emoji: '😩',
    text: 'Every week feels like starting from zero again.',
  },
  {
    emoji: '🌙',
    text: "You're still planning tomorrow's session late at night.",
  },
]

export const volumes = [
  {
    emoji: '🎾',
    volume: 'Volume 1',
    title: 'Core Drills Academy',
    text: 'Build strong technical foundations with progressive feeding patterns and ball-control drills.',
  },
  {
    emoji: '🏆',
    volume: 'Volume 2',
    title: 'Technical Masterclass',
    text: 'Correct every stroke with visual coaching cues and simple biomechanics.',
  },
  {
    emoji: '📋',
    volume: 'Volume 3',
    title: 'The Session Builder',
    text: 'Create professional sessions that scale perfectly for 3, 6 or 10+ players.',
  },
  {
    emoji: '📚',
    volume: 'Volume 4',
    title: 'Professional Blueprints',
    text: '50 complete plug-and-play practices from warm-up to match play.',
  },
  {
    emoji: '♟️',
    volume: 'Volume 5',
    title: 'Match Play & Strategy',
    text: 'Winning tactical patterns for juniors, adults and club players.',
  },
  {
    emoji: '🚀',
    volume: 'Volume 6',
    title: 'Elite Coach Business',
    text: 'Retention systems, academy organization and professional coaching strategies.',
  },
]

export const instantItems = [
  'The complete 6-volume Tennis Ready system',
  '120 ready coaching modules',
  '50 plug-and-play session blueprints',
  'Technical correction guides',
  'Court organization systems',
  'Season planning framework',
  'Assessment tools',
  'Professional coaching templates',
]

export const bonuses = [
  {
    title: 'The "Rainy Day" Classroom',
    subtitle:
      'Master tennis strategy and mental toughness without a court — stop cancelling, keep teaching.',
    was: '$27',
  },
  {
    title: 'The 52-Week Junior Pathway',
    subtitle:
      'The complete 1-year curriculum to pro-level development, from first swing to first tournament.',
    was: '$17',
  },
  {
    title: 'The Large Group Matrix',
    subtitle:
      'Dominating logistics: handle 8–15 players on 1 court with zero standing time and zero chaos.',
    was: '$17',
  },
  {
    title: 'The Adult Strategy Vault',
    subtitle:
      'Tactical win-states for club players — help them play smarter, not just hit better.',
    was: '$47',
  },
  {
    title: 'Visual On-Court Cheat Sheets',
    subtitle:
      'The no-brainer pocket guide: your coaching library compressed into 60-second diagrams and cues.',
    was: '$27',
  },
]

export const offerRows = [
  { label: '6 Complete Digital Volumes', value: '$97' },
  { label: '5 Exclusive Bonuses', value: '$135' },
]

export const testimonials = [
  {
    quote:
      'I planned my entire academy in one afternoon. Sundays are finally mine again.',
    name: 'Marcus G.',
    location: 'Sydney 🇦🇺',
  },
  {
    quote: 'The session blueprints completely changed the way I coach.',
    name: 'Laura P.',
    location: 'Florida 🇺🇸',
  },
  {
    quote: 'The 3-6-10 System solved the biggest problem in my academy.',
    name: 'Roberto M.',
    location: 'Spain 🇪🇸',
  },
  {
    quote:
      'Everything is organized exactly the way a professional coach needs.',
    name: 'Cecilia R.',
    location: 'Canada 🇨🇦',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: "Immediately after purchase you'll receive an email with instant access to all six PDF volumes.",
  },
  {
    q: 'Can I use it on my phone or tablet?',
    a: 'Yes. Every volume is optimized for computers, tablets and smartphones.',
  },
  {
    q: 'Is it suitable for beginners?',
    a: "Yes. Whether you're coaching your first season or running a large academy, the system is easy to follow.",
  },
  {
    q: 'Can I use it with different age groups?',
    a: 'Absolutely. The drills and session structures are designed to scale across junior and adult programs.',
  },
  {
    q: 'Are the bonuses included?',
    a: 'Yes. All 5 bonuses are included free during the launch promotion.',
  },
  {
    q: 'Is there any monthly subscription?',
    a: 'No. You pay once and keep lifetime access forever.',
  },
]
